import { Link } from "react-router-dom";
import type { BeautyArticle } from "@/mocks/beauty-info";
import { scrollToTop } from "@/components/feature/ScrollToTop";

export default function ArticleCard({ article }: { article: BeautyArticle }) {
  return (
    <Link
      to={`/beauty-info/${article.id}`}
      onClick={scrollToTop}
      className="group flex flex-col rounded-2xl overflow-hidden bg-white border border-background-200/70 transition-all hover:-translate-y-1 hover:border-primary-200 cursor-pointer"
    >
      <div className="relative w-full h-52 overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          title={`${article.title} - 비앙카 뷰티정보`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-medium text-primary-600">
          {article.category}
        </span>
      </div>
      <div className="flex flex-col gap-3 p-6 flex-1">
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.date}
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}
          </span>
        </div>
        <h3 className="text-lg font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">{article.excerpt}</p>
        <span className="mt-auto pt-2 inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:gap-2 transition-all">
          자세히 보기
          <i className="ri-arrow-right-line"></i>
        </span>
      </div>
    </Link>
  );
}